var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63.8873,
    height: 64,
    rx: 31.9437,
    fill: "#E9F1FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_3808)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6631 16H25.9899C27.2962 16.003 28.5482 16.5229 29.4723 17.4462C30.3964 18.3695 30.9175 19.621 30.9217 20.9273V30.9206H20.7346V20.9273C20.7385 19.6215 21.259 18.3703 22.1825 17.4471C23.106 16.5238 24.3573 16.0036 25.6631 16Z",
    fill: "#399918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 26.2189V25.9079C16.0027 24.6625 16.4983 23.4689 17.3786 22.588C18.2589 21.7071 19.4521 21.2106 20.6975 21.207L30.9217 30.9197H20.6975C19.4521 30.9161 18.2589 30.4196 17.3786 29.5387C16.4983 28.6578 16.0027 27.4642 16 26.2189Z",
    fill: "#295F98"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2242 16H37.8963C36.5902 16.0033 35.3385 16.5233 34.4146 17.4466C33.4907 18.3698 32.9698 19.6212 32.9656 20.9273V30.9206H43.1527V20.9273C43.1488 19.6215 42.6283 18.3703 41.7048 17.4471C40.7814 16.5238 39.53 16.0036 38.2242 16Z",
    fill: "#399918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8873 26.2189V25.9079C47.8846 24.6623 47.3888 23.4686 46.5083 22.5876C45.6278 21.7067 44.4343 21.2103 43.1887 21.207L32.9656 30.9197H43.1887C44.4343 30.9164 45.6278 30.42 46.5083 29.5391C47.3888 28.6582 47.8846 27.4644 47.8873 26.2189Z",
    fill: "#295F98"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6631 47.8904H25.9899C27.2962 47.8869 28.548 47.3666 29.4721 46.4432C30.3961 45.5198 30.9172 44.2683 30.9217 42.962V32.9688H20.7346V42.962C20.7388 44.2678 21.2594 45.519 22.1828 46.4423C23.1061 47.3657 24.3573 47.8863 25.6631 47.8904Z",
    fill: "#399918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 37.6673V37.9806C16.0033 39.2255 16.4992 40.4186 17.3794 41.299C18.2596 42.1794 19.4525 42.6756 20.6975 42.6792L30.9217 32.9688H20.6975C19.4525 32.9723 18.2596 33.4685 17.3794 34.3489C16.4992 35.2294 16.0033 36.4224 16 37.6673Z",
    fill: "#295F98"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2242 47.8904H37.8963C36.5902 47.8866 35.3387 47.3662 34.4149 46.4428C33.4911 45.5194 32.9701 44.2681 32.9656 42.962V32.9688H43.1527V42.962C43.1485 44.2678 42.6279 45.519 41.7046 46.4423C40.7812 47.3657 39.5301 47.8863 38.2242 47.8904Z",
    fill: "#399918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8873 37.6673V37.9806C47.8841 39.2257 47.388 40.4189 46.5075 41.2994C45.6271 42.1798 44.4339 42.6759 43.1887 42.6792L32.9656 32.9688H43.1887C44.4339 32.972 45.6271 33.4681 46.5075 34.3485C47.388 35.229 47.8841 36.4222 47.8873 37.6673Z",
    fill: "#295F98"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_3808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.8873,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/default-icon.a2fc2300481cebb2cce60c773dfc8e5c.svg";
export { ForwardRef as ReactComponent };